export type DisplayDesignItem = {
  id?: string,
  name: string,
  user_id?: number;
  css: string;
  header_html: string;
  footer_html: string
  is_public: number;
  comment: string;
  is_pc: number;
}

export const CreateNewDesignItem = (): DisplayDesignItem => {
  return {
    comment: "test",
    header_html: "",
    footer_html: "",
    css: "",
    is_pc: 1,
    is_public: 0,
    name: "新しいデザイン",
  }
}